import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import { FastCheckoutActionTypes } from './fastcheckout.types';
import { isBRServer } from '@/utils/Validators/validation';
import { COUNTRY, WHMCS_URL } from '@/config';
import { api } from '@/utils/api';
import { commonActions } from '../common';
import { locale } from '@/utils/locale';
import logger from '@/utils/logger';
import fastCheckoutAssembly from './fastcheckout.assembly';
import fastCheckoutActions from './fastcheckout.actions';

function* requestFastCheckoutProduct(action) {
  const { coupon, pid, billingCycle } = action.payload;
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';

  const request = {
    url: `${WHMCS_URL}/api/v3/fast_checkout_product/${pid}`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand,
    },
    data: {
      coupon_code: coupon,
      cycle: billingCycle,
    },
  };

  yield put(fastCheckoutActions.loading(true));

  try {
    const response = yield call(api.whmcs.post, request);
    const parsedProduct = fastCheckoutAssembly.receiveFastCheckoutProduct(response);
    yield put(fastCheckoutActions.product.set(parsedProduct));
    yield put(fastCheckoutActions.product.success());
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error checking fast checkout product info', error);
    yield put(fastCheckoutActions.product.failure());
    yield put(commonActions.notifications.set({
      label: locale('fastCheckout.errorToast'),
      type: 'error',
    }));
  }
  yield put(fastCheckoutActions.loading(false));
}

function* fastCheckoutPurchase(action) {
  const {
    discount, product, paymentMethod, onSuccessCallback,
  } = action.payload;
  const { token, jwt: jwtToken } = yield select(state => state.auth);

  yield put(fastCheckoutActions.purchase.setError(false));

  const request = {
    url: `${WHMCS_URL}/api/v3/fastcheckout`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken,
      brand: COUNTRY,
    },
    data: {
      discount,
      product,
      paymentMethod,
      domain: [], // Note: Not implemented yet
      fingerprint: '',
    },
  };

  yield put(fastCheckoutActions.loading(true));

  try {
    yield call(api.whmcs.post, request);
    yield put(fastCheckoutActions.purchase.success());

    onSuccessCallback && onSuccessCallback();
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error purchasing product in fastcheckout', error);
    yield put(fastCheckoutActions.purchase.setError(true));
  }
  yield put(fastCheckoutActions.loading(false));
}

function* sagas() {
  yield takeLatest(FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PRODUCT, requestFastCheckoutProduct);
  yield takeLatest(FastCheckoutActionTypes.REQUEST_FAST_CHECKOUT_PURCHASE, fastCheckoutPurchase);
}

export default sagas;
